export const destinationsDe = [
  {
    text: "AFRIKA",
    value: "11974",
  },
  {
    text: "ALASKA",
    value: "11976",
  },
  {
    text: "ANTARKTIS",
    value: "11985",
  },
  {
    text: "ARKTIS",
    value: "11987",
  },
  {
    text: "ASIEN",
    value: "11990",
  },
  {
    text: "Indischer Ozean",
    value: "12030",
  },
  {
    text: "Südostasien",
    value: "12091",
  },
  {
    text: "ATLANTIK",
    value: "11992",
  },
  {
    text: "AUSTRALIEN",
    value: "11994",
  },
  {
    text: "BENELUX",
    value: "11997",
  },
  {
    text: "Schelde",
    value: "12081",
  },
  {
    text: "BRITISCHE INSELN",
    value: "12001",
  },
  {
    text: "DONAU",
    value: "12009",
  },
  {
    text: "Donaudelta",
    value: "12010",
  },
  {
    text: "Main-Donau-Kanal",
    value: "12042",
  },
  {
    text: "ELBE",
    value: "12012",
  },
  {
    text: "Havel",
    value: "12027",
  },
  {
    text: "Moldau",
    value: "12050",
  },
  {
    text: "Spree",
    value: "15507",
  },
  {
    text: "FRANKREICH",
    value: "12016",
  },
  {
    text: "Loire",
    value: "12038",
  },
  {
    text: "Rhône",
    value: "12077",
  },
  {
    text: "Saône",
    value: "12080",
  },
  {
    text: "Seine",
    value: "12085",
  },
  {
    text: "HAWAII",
    value: "12028",
  },
  {
    text: "KANARISCHE INSELN",
    value: "12034",
  },
  {
    text: "KARIBIK",
    value: "12035",
  },
  {
    text: "Südliche Karibik",
    value: "12090",
  },
  {
    text: "Westliche Karibik",
    value: "12105",
  },
  {
    text: "MEXIKANISCHE RIVIERA",
    value: "12045",
  },
  {
    text: "MISSISSIPPI",
    value: "12046",
  },
  {
    text: "MITTELAMERIKA",
    value: "12047",
  },
  {
    text: "MITTELLANDKANAL",
    value: "12048",
  },
  {
    text: "MITTELMEER",
    value: "12049",
  },
  {
    text: "Östliches Mittelmeer",
    value: "12069",
  },
  {
    text: "Schwarzes Meer",
    value: "12083",
  },
  {
    text: "Westliches Mittelmeer",
    value: "12106",
  },
  {
    text: "NEUSEELAND",
    value: "12056",
  },
  {
    text: "NORDAMERIKA",
    value: "12059",
  },
  {
    text: "Große Seen",
    value: "12023",
  },
  {
    text: "Neuengland",
    value: "12055",
  },
  {
    text: "USA Ostküste",
    value: "12098",
  },
  {
    text: "USA Westküste",
    value: "12099",
  },
  {
    text: "NORDLAND",
    value: "12060",
  },
  {
    text: "Grönland",
    value: "12022",
  },
  {
    text: "Island",
    value: "12032",
  },
  {
    text: "NORD-PAZIFIK",
    value: "12062",
  },
  {
    text: "NORDSEE",
    value: "12063",
  },
  {
    text: "ODER",
    value: "12064",
  },
  {
    text: "Oder-Havel-Kanal",
    value: "12065",
  },
  {
    text: "ORIENT U. EMIRATE",
    value: "12066",
  },
  {
    text: "OSTSEE",
    value: "12070",
  },
  {
    text: "Nord-Ostsee-Kanal",
    value: "12061",
  },
  {
    text: "OSTSEEKÜSTE",
    value: "12071",
  },
  {
    text: "PANAMA-KANAL",
    value: "12072",
  },
  {
    text: "RHEIN",
    value: "12076",
  },
  {
    text: "Main-Donau-Kanal",
    value: "12041",
  },
  {
    text: "Mosel",
    value: "12051",
  },
  {
    text: "Neckar",
    value: "12054",
  },
  {
    text: "ROTES MEER",
    value: "12078",
  },
  {
    text: "Suez-Kanal-Passage",
    value: "12095",
  },
  {
    text: "SÜDAMERIKA",
    value: "12088",
  },
  {
    text: "Amazonas",
    value: "11978",
  },
  {
    text: "Galápagos",
    value: "12017",
  },
  {
    text: "SÜD-EUROPA",
    value: "12089",
  },
  {
    text: "Douro",
    value: "12011",
  },
  {
    text: "Po",
    value: "12074",
  },
  {
    text: "SÜD-PAZIFIK",
    value: "12093",
  },
  {
    text: "SÜDSEE",
    value: "12094",
  },
  {
    text: "TRANSATLANTIK",
    value: "12097",
  },
  {
    text: "WELTREISE",
    value: "12103",
  },
  {
    text: "WEST-EUROPA",
    value: "12104",
  },
  {
    text: "KARIBASEE",
    value: "15432",
  },
];
